import { render, staticRenderFns } from "./ListRefundKonser.vue?vue&type=template&id=cb65711c&"
import script from "./ListRefundKonser.vue?vue&type=script&lang=js&"
export * from "./ListRefundKonser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports